import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Button, Table, FormGroup, Label, Input, Alert, Card, CardBody, Row, Col, CardHeader, CardTitle } from 'reactstrap';
import axios from 'axios';
import Select from 'react-select';
import { BASE_URL } from '../../../constants';

function EditUser() {
	const navigate = useNavigate();
	const { id } = useParams();
	const [errMsg, setErrMsg] = useState(null);
	const [successMsg, setSuccessMsg] = useState(null);
	const [formData, setFormData] = useState({
		first_name: '',
		last_name: '',
		email: '',
		phone: '',
	});
	const [passwordData, setPasswordData] = useState({
		password: '',
		confirm_password: '',
	});
	const [packages, setPackages] = useState([]);
	const [selectedPackage, setSelectedPackage] = useState(null);
	const [userPackageDetails, setUserPackageDetails] = useState(null);
	
	const packageSelectOpts = [...packages.map(p => ({
		value: p.id, 
		label: `${p.title} - $${p.amount}`,
		isDisabled: p.is_trial_package === 0
	}))]
	
	useEffect(() => {
		const token = localStorage.getItem('token');
		if (!token) {
			throw new Error('Authorization token is missing.');
		}
		(async () => {
			const response = await axios.get(`${BASE_URL}/user/super-admin/get/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			if (response.data.status) {
				setFormData({
					...formData,
					first_name: response.data.result.first_name || '',
					last_name: response.data.result.last_name || '',
					email: response.data.result.email || '',
					phone: response.data.result.phone || '',
				})

				if (response.data.result.package_id) {
					setSelectedPackage(response.data.result.package_id)
				}

				setUserPackageDetails({
					package_id: response.data.result.package_id,
					package_title: response.data.result.package_title,
					subscription_id: response.data.result.subscription_id,
					subscription_type: response.data.result.subscription_type,
					subscription_created_at: response.data.result.subscription_created_at,
				})
			}
			
			const responsePackage = await axios.get(`${BASE_URL}/package/list`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			if (responsePackage.data.status) {
				setPackages([...responsePackage.data.result.data])
			}
		})()
	}, [id])

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value
		});
	};

	const handleSubmit = async () => {
		try {
			setErrMsg(null);
			setSuccessMsg(null);

			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const response = await axios.post(`${BASE_URL}/user/super-admin/update/${id}`, {
				...formData,
			}, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			if (response.data.status) {
				// navigate('/user');
				setSuccessMsg(response.data.message);
			}
			else {
				setErrMsg(response.data.message);
			}
		} catch (error) {
			setErrMsg(error);
		}
	};

	const handlePasswordSubmit = async () => {
		setErrMsg(null);
		setSuccessMsg(null);

		const token = localStorage.getItem('token');
		if (!token) {
			throw new Error('Authorization token is missing.');
		}

		const response = await axios.post(`${BASE_URL}/user/super-admin/update/${id}`, {
			...passwordData,
		}, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
		if (response.data.status) {
			// navigate('/user');
			setSuccessMsg(response.data.message);
			setPasswordData({
				password: '',
				confirm_password: '',
			})
		}
		else {
			setErrMsg(response.data.message);
		}
	}

	const handlePackageSubmit = async () => {
		setErrMsg(null);
		setSuccessMsg(null);

		const token = localStorage.getItem('token');
		if (!token) {
			throw new Error('Authorization token is missing.');
		}

		const response = await axios.post(`${BASE_URL}/user/super-admin/update-package/${id}`, {
			package_id: selectedPackage,
		}, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
		if (response.data.status) {
			setSuccessMsg(response.data.message);
			window.location.reload();
		}
		else {
			setErrMsg(response.data.message);
		}
	}

	return (
		<div className="content">
			{errMsg && <Alert color="danger">{errMsg}</Alert>}
			{successMsg && <Alert color="success">{successMsg}</Alert>}

			<h3>Edit User</h3>

			<Row>
				<Col>
					<Card>
						<CardHeader>
							<CardTitle tag="h4">Profile</CardTitle>
						</CardHeader>
						<CardBody>
							<FormGroup>
								<Label for="first_name">First Name*</Label>
								<Input type="text" name="first_name" id="first_name" value={formData.first_name} onChange={handleChange} />
							</FormGroup>
							<FormGroup>
								<Label for="last_name">Last Name*</Label>
								<Input type="text" name="last_name" id="last_name" value={formData.last_name} onChange={handleChange} />
							</FormGroup>
							<FormGroup>
								<Label for="email">Email*</Label>
								<Input type="email" name="email" id="email" value={formData.email} onChange={handleChange} />
							</FormGroup>
							<FormGroup>
								<Label for="phone">Phone</Label>
								<Input type="number" name="phone" id="phone" value={formData.phone} onChange={handleChange} />
							</FormGroup>
							
							<Button color="primary" type="button" onClick={handleSubmit}>Submit</Button>
						</CardBody>
					</Card>

					<Card>
						<CardHeader>
							<CardTitle tag="h4">Update Password</CardTitle>
						</CardHeader>
						<CardBody>
							<FormGroup>
								<Label for="password">Password</Label>
								<Input type="password" name="password" id="password" 
									value={passwordData.password} 
									onChange={e => setPasswordData({ ...passwordData, [e.target.name]: e.target.value })} 
								/>
							</FormGroup>
							<FormGroup>
								<Label for="last_name">Confirm Password</Label>
								<Input type="password" name="confirm_password" id="confirm_password" 
									value={passwordData.confirm_password} 
									onChange={e => setPasswordData({ ...passwordData, [e.target.name]: e.target.value })} 
								/>
							</FormGroup>

							<Button color="primary" type="button" onClick={handlePasswordSubmit}>Update Password</Button>
						</CardBody>
					</Card>
				</Col>
				<Col>
					<Card>
						<CardHeader>
							<CardTitle tag="h4">Package</CardTitle>
						</CardHeader>
						<CardBody>
							<Label>Current Subscription</Label>
							<Table responsive bordered striped>
								<thead>
									<tr>
										<th>Package</th>
										<th>Type</th>
										<th>Purchased On</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{packages.find(p => p.id === userPackageDetails?.package_id)?.title}</td>
										<td>{userPackageDetails?.subscription_type}</td>
										<td>{(userPackageDetails && userPackageDetails.subscription_created_at) ? new Date(userPackageDetails.subscription_created_at).toLocaleDateString('en-US') : '-'}</td>
									</tr>
								</tbody>
							</Table>
							<FormGroup>
								<Label for="package">Select Package</Label>
								<Select
									name="package"
									id="package"
									options={packageSelectOpts}
									value={packageSelectOpts.find(p => p.value === selectedPackage)}
									onChange={e => setSelectedPackage(e.value)}
									placeholder="Select Package"
								/>
							</FormGroup>

							<Button color="primary" type="button" onClick={handlePackageSubmit}>Update Package</Button>
						</CardBody>
					</Card>

					{/* <Card>
						<CardHeader>
							<CardTitle tag="h4">Danger Zone</CardTitle>
						</CardHeader>
						<CardBody></CardBody>
					</Card> */}
				</Col>
			</Row>


		</div>
	);
}

export default EditUser;
